export default "__VITE_ASSET__9ypo7G2V__"